const images = {
    //josh lol
    josh: {
        josh: "josh",
        url: process.env.PUBLIC_URL+'/images/josh.gif'
    },
    // MAIN PAGE
    binari: {
        alt: "binari from the dark lord's confession",
        url: process.env.PUBLIC_URL+'/images/binari.jpg'
    },
    strawberrygif: {
        alt: "bouncing strawberry gif",
        url:  process.env.PUBLIC_URL+ "/images/deco/strawberry_bunny2.gif"
    },
    birdgif: {
        alt: "bouncing strawberry gif",
        url:  process.env.PUBLIC_URL+ "/images/deco/strawberry_bunny.gif"
    },
    sleepykitty:{
        alt: "sleeping cat",
        url: process.env.PUBLIC_URL+ "/images/deco/sleepykitty.png"
    },
    bao: {
        url: process.env.PUBLIC_URL+ "/images/deco/bao.png" 
    },
    bao2: {
        url: process.env.PUBLIC_URL+ "/images/deco/bao2.png" 
    },

    // ABOUT
    button: {
        alt: "my button",
        url: process.env.PUBLIC_URL+ "/images/marketchipping.gif"

    }, 
    aya: {
        url: process.env.PUBLIC_URL+ "/images/aya.jpg"
    },
   
    // PHOTOCARD
    choerry:{
        alt: "choerry from loona",
        url: process.env.PUBLIC_URL+ "/images/ARTMS_Birth_visuals_Choerry_2.webp"
    },
    chuu:{
        alt: "chuu from loona",
        url: process.env.PUBLIC_URL+ "/images/chuu.jpg"
    },
     pearlheart:{
        alt: "heart made of pearls",
        url: process.env.PUBLIC_URL+ "/images/deco/pearlheart.png"
    },
    flower1:{
        alt: "pressed flower",
        url: process.env.PUBLIC_URL+ './images/deco/flo18.png'
    },
    flower2:{
        alt: "pressed flower",
        url: process.env.PUBLIC_URL+ './images/deco/flo20.png'
    },
    sando:{
        alt: "pressed flower",
        url: process.env.PUBLIC_URL+ './images/deco/sando.gif'
    },
    hologif:{
        alt: "pressed flower",
        url: process.env.PUBLIC_URL+ './images/deco/hologif.gif'
    },
    mail:{
        url: process.env.PUBLIC_URL+ './images/mail.webp'
    },
    // GAMES
    solitaired: {
        alt: "solitaired url",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/solitaired.png'
    },
    wordle: {
        alt: "solitaired url",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/wordle.png'
},
ratchelor: {
        alt: "ratchelor url",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/ratchelor.png'
},
infiniteCraft: {
        alt: "infinite craft",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/infinite-craft.png'
},
stimulationClicker: {
        alt: "",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/stimulation-clicker.png'
},
aislop: {
    alt: "",
    url:  process.env.PUBLIC_URL+ './images/info-page-images/aislop.jpg'
},
penultima: {
    alt: "",
    url:  process.env.PUBLIC_URL+ './images/info-page-images/penultima.png'
},
    //GRAPHICS
    strawberrybunny: {
        alt: "strawberrybunny",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/strawberrybunny.gif'

    },
    killychan: {
         alt: "strawberrybunny",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/killychan.gif'
    },
    allyratworld: {
         alt: "allyratworld",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/buttonneo.png'
    },
    graphicshoard: {
         alt: "graphics-hoard",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/dragoncrystal.gif'
    },
    xixxii: {
         alt: "graphics-hoard",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/home04.gif'
    },
    engrampixek: {
         alt: "engrampixel",
        url:  'http://media.tumblr.com/tumblr_m5106aHKT11qid2nw.gif'
    },
    velvetmoth: {
        alt: "velvet moth",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/velvet_moth.gif'
    },
    pixelsafari: {
        alt: "pixelsafari",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/pixelsafari.gif'
    },
    rentryresource: {
        alt: "rentryresource",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/rentry resource.gif'
    },
    //INSPO
    mushmallow: {
         alt: "mushmallow",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/mushmallow.png'
    },
    oniocafe: {
         alt: "oniocafe",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/oniocafe.gif'
    },
    olliveen: {
        alt: "olliveen",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/olliveen.gif'
    },
    hillhouse: {
        alt: "hillhouse",
        url:  process.env.PUBLIC_URL+ './images/info-page-images/hillhouse-sunset.png'

    }
}

export default images;